import React, { FC, HTMLAttributes, RefCallback, RefObject } from 'react';
// @ts-ignore
import BrowserSymbol from 'svg-baker-runtime/browser-symbol';
// @ts-ignore
import { assign } from 'es6-object-assign';
import { addSpriteSymbol, useIsomorphicLayoutEffect } from '../sprite';
import { SvgIcon } from '../SvgIcon';

const viewBox = '0 0 24 24';
const id = 'share_24';
const content = '<symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="share_24"><g fill="none" fill-rule="evenodd"><path d="M0 0h24v24H0z" /><path d="M13 8.75V4.581a.5.5 0 01.824-.38l8.728 7.418a.5.5 0 010 .762L13.824 19.8a.5.5 0 01-.824-.381V15.25c-5.346 0-9.14 1.145-11.38 3.435a.25.25 0 01-.422-.232C2.703 11.984 6.637 8.75 13 8.75zm0 0V4.581a.5.5 0 01.824-.38l8.728 7.418a.5.5 0 010 .762L13.824 19.8a.5.5 0 01-.824-.381V15.25c-5.346 0-9.14 1.145-11.38 3.435a.25.25 0 01-.422-.232C2.703 11.984 6.637 8.75 13 8.75z" fill="currentColor" fill-rule="nonzero" /></g></symbol>';

let isMounted = false;
function mountIcon() {
  if (!isMounted) {
    addSpriteSymbol(new BrowserSymbol({
      id: id,
      viewBox: viewBox,
      content: content,
    }));

    isMounted = true;
  }
}

export interface Icon24ShareProps extends HTMLAttributes<HTMLDivElement> {
  fill?: string;
  width?: number;
  height?: number;
  getRootRef?: RefCallback<HTMLDivElement> | RefObject<HTMLDivElement>;
}

const Icon24Share: FC<Icon24ShareProps> = (props) => {
  useIsomorphicLayoutEffect(() => {
    mountIcon();
  }, []);

  return React.createElement(SvgIcon, assign({}, props, {
    viewBox: viewBox,
    id: id,
    width: !isNaN(props.width) ? +props.width : 24,
    height: !isNaN(props.height) ? +props.height : 24,
  }));
};

(Icon24Share as any).mountIcon = mountIcon;

export default Icon24Share;
